<script>
export default {
  name: "IconEnter"
};
</script>

<template>
  <svg width="10" height="11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 5.33V.8a.8.8 0 0 0-1.6 0v4.53a.81.81 0 0 1-.8.82H2.732L4.18 4.666a.81.81 0 1 0-1.16-1.132L.235 6.39a.83.83 0 0 0 0 1.16l2.785 2.856a.81.81 0 0 0 1.16-1.132L2.732 7.79H7.6c1.326 0 2.4-1.102 2.4-2.46Z"
      fill="#fff"
    />
  </svg>
</template>
